export default __webpack_public_path__ + "static/media/18.0d049bc6.png";